module.exports = __webpack_public_path__ + "laixinzhanshi.png?7d4462f9ba2d821c629f255cbede7436";


//////////////////
// WEBPACK FOOTER
// ./static/assets/laixinzhanshi.png
// module id = 536
// module chunks = 0